import { useContext, useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { RootStore, RootStoreContext } from '../../stores/rootStore';

const AccountMenu = observer(() => {
    const { userStore, subscriptionsStore }: RootStore = useContext(RootStoreContext);
    const { user, isLoggedIn, OpenLoginForm } = userStore;
    //a subscription needs action (failed payment / expired / expiring): the badge stays even
    //after the attention bar was dismissed for the session
    const attention = subscriptionsStore.attention;
    const attentionText = attention?.kind === 'pastDue' ? 'Renewal payment failed'
        : attention?.kind === 'expired' ? 'Subscription expired'
        : attention ? 'Subscription expiring soon' : null;
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    if (!isLoggedIn) {
        return <button className="auth-signin" type="button" onClick={OpenLoginForm}>Sign in</button>;
    }

    const initial = (user?.userName || user?.email || '?')[0].toUpperCase();

    return (
        <div className={`auth-menu${open ? ' open' : ''}`} ref={ref}>
            <button className="auth-trigger" type="button" onClick={() => setOpen(o => !o)} title={attentionText ?? undefined}>
                <span className="auth-avatar">
                    {initial}
                    {attention && <span className="auth-badge" aria-label={attentionText ?? 'Attention needed'} />}
                </span>
                <span className="auth-label">{user?.userName || user?.email}</span>
                <svg className="auth-caret" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                    <polyline points="6 9 12 15 18 9"/>
                </svg>
            </button>
            <div className="auth-pop">
                <div className="auth-pop-head">
                    <span className="auth-avatar lg">{initial}</span>
                    <div>
                        <div className="auth-pop-name">{user?.userName}</div>
                        <div className="auth-pop-email">{user?.email}</div>
                    </div>
                </div>
                {attentionText && (
                    <a className="auth-pop-item auth-pop-attention" href="/subscriptions" onClick={() => setOpen(false)}>
                        <span className="auth-badge inline" />{attentionText}
                    </a>
                )}
                <a className="auth-pop-item" href="/subscriptions" onClick={() => setOpen(false)}>Your subscriptions</a>
                <a className="auth-pop-item" href="/purchase" onClick={() => setOpen(false)}>Buy</a>
                <a className="auth-pop-item auth-signout" href="/logout">Sign out</a>
            </div>
        </div>
    );
});

export default AccountMenu;
